export function toFixed (number, point) {
  const numArr = Number(number).toFixed(point + 1).split('.')
  // 判断个位大于等于5，加1
  if (numArr.length > 1 && Number(numArr[1]) % 10 >= 5) numArr[1] = Number(numArr[1]) + 1
  return Number(numArr.join('.')).toFixed(point)
}

/**
 * 
 * @param {string} href 
 * @returns string
 */
export function GetRequest (href) {
  const splitIndex = href.indexOf('?')
  let path = href.substr(splitIndex === -1 ? href.length : splitIndex + 1, href.length)
  path = path.replace(/\?/g, '&')

  const params = {}
  if (path.length > 0) {
    const strs = path.split('&')
    for (let i = 0; i < strs.length; i++) {
      params[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  return params
}

// 判断是否是微信环境
export function isWxEnv () {
  const ua = navigator.userAgent
  const isWx = /micromessenger/i.test(ua.toLowerCase())
  return isWx
}
